import {
  GetBillingPlanEnum,
  GetBillingResponseType,
} from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { BILLING } from '../apis';

const defaultValue: GetBillingResponseType = {
  plan: GetBillingPlanEnum.EXPIRY,
  country: 'TW',
};

async function getGetBilling(
  projectID?: string,
): Promise<GetBillingResponseType> {
  return (
    axios
      .get(
        `${BILLING}`,
        // 指定專案時明確帶 header，全域攔截器會優先採用（仍保有 401/403 的全域處理）
        projectID ? { headers: { 'project-id': projectID } } : undefined,
      )
      .then((res) => res.data.data)
      // 結帳頁要分辨「真的沒有付費方案」與「查不到」：查不到時不能把付費客戶當成新客預設年繳
      .catch((err) => ({ ...defaultValue, isFallback: true }))
  );
}

export function useGetBilling(enabled = true, projectID?: string) {
  // 呼叫端有已解析的專案時以它為準；sessionStorage 只記最後查過的專案，
  // 快取期間切回別的專案時不會重寫，會拿到錯的專案方案（2026-10 結帳頁 Codex review）
  const scopedProjectID = projectID ?? sessionStorage.getItem('project-id');
  return useQuery<GetBillingResponseType>({
    queryKey: ['get-billing', { projectID: scopedProjectID }],
    queryFn: () => {
      // 送出時用同一個快照：key 與實際 header 一定指向同一專案，不會把 B 的資料存進 A 的 key
      if (scopedProjectID) return getGetBilling(scopedProjectID);
      else return defaultValue;
    },
    // sessionStorage 可能殘留別的專案 id（standalone /upgrade 新購時），
    // 呼叫端可用 enabled 擋掉不該發生的 project-scope 請求（403 會被全域導轉走）
    enabled,
  });
}

export default useGetBilling;
